var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganizationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7087 5.13672L8.14746 7.81335",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1781 7.841L17.6436 5.19141",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5254 17.4108V12.1387",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5908 24.3075L22.1787 21.6309",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06934 21.6016L12.6839 24.3052",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74805 12.0059V17.3862",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1364 6.62364C16.6685 6.62364 17.9105 5.36474 17.9105 3.81182C17.9105 2.25889 16.6685 1 15.1364 1C13.6043 1 12.3623 2.25889 12.3623 3.81182C12.3623 5.36474 13.6043 6.62364 15.1364 6.62364Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1364 28.3619C16.6685 28.3619 17.9105 27.103 17.9105 25.5501C17.9105 23.9972 16.6685 22.7383 15.1364 22.7383C13.6043 22.7383 12.3623 23.9972 12.3623 25.5501C12.3623 27.103 13.6043 28.3619 15.1364 28.3619Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77408 12.0572C7.30617 12.0572 8.54817 10.7983 8.54817 9.24541C8.54817 7.69249 7.30617 6.43359 5.77408 6.43359C4.242 6.43359 3 7.69249 3 9.24541C3 10.7983 4.242 12.0572 5.77408 12.0572Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.1946C3 21.7357 4.227 23.0064 5.77408 23.0064C7.32117 23.0064 8.54817 21.7628 8.54817 20.1946C8.54817 18.6535 7.32117 17.3828 5.77408 17.3828C5.74741 17.3828 5.69406 17.3828 5.66739 17.3828C4.17365 17.4639 3 18.6806 3 20.1946Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.526 23.0065C26.0581 23.0065 27.3001 21.7476 27.3001 20.1946C27.3001 18.6417 26.0581 17.3828 24.526 17.3828C22.994 17.3828 21.752 18.6417 21.752 20.1946C21.752 21.7476 22.994 23.0065 24.526 23.0065Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.526 12.0572C26.0581 12.0572 27.3001 10.7983 27.3001 9.24541C27.3001 7.69249 26.0581 6.43359 24.526 6.43359C22.994 6.43359 21.752 7.69249 21.752 9.24541C21.752 10.7983 22.994 12.0572 24.526 12.0572Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0561 19.0301C17.3102 19.0301 19.1375 17.2027 19.1375 14.9486C19.1375 12.6945 17.3102 10.8672 15.0561 10.8672C12.8019 10.8672 10.9746 12.6945 10.9746 14.9486C10.9746 17.2027 12.8019 19.0301 15.0561 19.0301Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationsIcon);
export default __webpack_public_path__ + "static/media/organizations_icon.9a7642ba.svg";
export { ForwardRef as ReactComponent };